import { t } from "i18next";
import { z } from "zod";

interface EmailChange {
  newEmail: string;
  confirmNewEmail: string;
}

export const EmailChangeSchema = (): z.ZodEffects<z.ZodType<EmailChange>> =>
  z
    .object({
      newEmail: z.string().email(t("schemas.emailChange.invalidEmail")),
      confirmNewEmail: z.string().email(t("schemas.emailChange.invalidEmail")),
    })
    .refine((data) => data.newEmail === data.confirmNewEmail, {
      message: t("schemas.emailChange.emailNotMatch"),
      path: ["newEmail"],
    });

export type EmailChangeSchemaType = z.infer<
  ReturnType<typeof EmailChangeSchema>
>;

export type EmailChangeSchemaKey = keyof EmailChangeSchemaType;
